import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const RoundsService = {
  async getById(roundId) {
    return safeRequest(
      apiClient.get(`/rounds/${roundId}`).then((response) => response.data),
    );
  },
  async generate(roundId) {
    return safeRequest(
      apiClient.post(`/rounds/${roundId}/generate`).then((response) => response.data),
    );
  },
};
